import { Checkbox, Label } from '@purpur/library';
import styled, { css } from 'styled-components';

import { getPurpurColor, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const StyledLabel = styled(Label)`
    position: relative;
    display: flex;
    align-items: flex-start;
    width: fit-content;
`;

export const StyledCheckbox = styled(Checkbox)`
    [class*='_purpur-checkbox__label-container'] {
        display: none;
    }
    [class*='_purpur-checkbox__container'] {
        padding-left: 0.625rem;
        padding-right: 0.625rem;
    }
    button[class^='_purpur-checkbox'] {
        position: relative;
        padding: 0;
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 0;
    }
`;

type DisabledProps = {
    $isDisabled?: boolean;
};

export const CheckboxText = styled.div<DisabledProps>`
    padding-top: 0.625rem;
    font-family: ${getPurpurTypography('familyDefault')};
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightNormal')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
    color: ${getPurpurColor('textDefault')};
    display: block;
    hyphens: none;
    margin: 0;

    ${({ $isDisabled }) =>
        $isDisabled &&
        css`
            color: ${getPurpurColor('textWeak')};
        `};
`;
